export default "__VITE_ASSET__de234221__"